import { isDefined } from '../is-defined';
import { compare } from '../comparators/compare';
var SortingType;
(function (SortingType) {
    SortingType[SortingType["ASC"] = 1] = "ASC";
    SortingType[SortingType["DSC"] = -1] = "DSC";
})(SortingType || (SortingType = {}));
/**
 * @name sortByItemField
 * @description This function will sort an array of object by the given field
 * @param {T[]} array The array to sort
 * @param {string} field The field to use for the sorting
 * @param {SortOptions} sortingType { ASC - DSC }
 * @returns {T[]} The sorted array
 *
 * @example
 * // Without option
 * import {sortByItemField, SortingType} from 'gso-utilities';
 * const array = [{name:'Spiderman'},{name:'Hulk'},{name:'Thor'}];
 * const newArray = sortByItemField(array,'name');
 * console.log(newArray); // [{name:'Hulk'},{name:'Spiderman'},{name:'Thor'}]
 *
 * @example
 * // With option Ascendant
 * import {sortByItemField, SortingType} from 'gso-utilities';
 * const array = [{name:'Spiderman'},{name:'Hulk'},{name:'Thor'}];
 * const newArray = sortByItemField(array,'name', SortingType.ASC);
 * console.log(newArray); // [{name:'Hulk'},{name:'Spiderman'},{name:'Thor'}]
 *
 * @example
 * // With option Descendant
 * import {sortByItemField, SortingType} from 'gso-utilities';
 * const array = [{name:'Spiderman'},{name:'Hulk'},{name:'Thor'}];
 * const newArray = sortByItemField(array,'name', SortingType.DESC);
 * console.log(newArray); // [{name:'Thor'},{name:'Spiderman'},{name:'Hulk'}]
 */
function sortByItemField(array, field, sortingType = SortingType.ASC) {
    if (!isDefined(array) || !isDefined(field)) {
        return array;
    }
    const modifier = isDefined(sortingType)
        ? sortingType
        : SortingType.ASC;
    return array.sort((itemA, itemB) => {
        return modifier * compare(itemA[field], itemB[field]);
    });
}
export { SortingType, sortByItemField };
//# sourceMappingURL=sort-by-item-field.js.map